import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName, processApi } from "../../../../utility/index"
import moment from "moment";

export default {
    components: { iTable, IPagination },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                companyName: '',
                changeExpireDate: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.manufactureNum')
            }, {
                value: '3',
                label: this.$t('common.plateNum')
            }],
            height: '550',
            list: [
            ], 
            option: {
                stripe: true, 
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "160px"

                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "nowExpireDate",
                    label: this.$t('GovernmentRegulation.nowExpireDate'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "changeExpireDate",
                    label: this.$t('GovernmentRegulation.changeExpireDate'),
                    align: "center",

                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont icontupian',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogImgFormVisible = true
                            this.imgUrl = row.filePath
                        }
                    },
                    {
                        id: '2',
                        show: true,
                        icon: 'iconfont iconshenpi',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogFormVisible = true
                            this.btnType = 'opreate'
                            this.oddNum = row.oddNum
                        }
                    }
                ],
            },
            oddNum: '',
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '112px',
            form: {
                auditState: 1,
                auditOpinion: ''
            },
            selected: [],
            btnType: '',

            dialogImgFormVisible: false,
            imgUrl: '',
        }
    },
    mounted() {
        this.getCarAnnualList()
    },
    methods: {
        getCarAnnualList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.changeExpireDate) {
                if (this.formInline.changeExpireDate.length > 0) {
                    startTime = this.formInline.changeExpireDate[0]
                    endTime = this.formInline.changeExpireDate[1]
                }
            }
            let param = {
                auditType: 0,
                jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                companyName: this.formInline.companyName,
                changeExpireDateStar: startTime,
                changeExpireDateEnd: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('AnnualReview/GET_GETANNUALAPPROVELIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getCarAnnualList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                companyName: '',
                changeExpireDate: [],
            }
            this.getCarAnnualList()
        },

        examine() {
            this.dialogFormVisible = true
            this.btnType = 'examine'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.btnType == 'examine') {
                        let param = {
                            oddNums: this.selected.map(item => item.oddNum).join(),
                            auditType: 0,
                            auditState: this.form.auditState,
                            auditOpinion: this.form.auditOpinion,
                        }
                        this.$store.dispatch('AnnualReview/GET_BATCHUPDATEAUDIT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getCarAnnualList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }
    
                        }).catch(err => { })
                    }else {
                        let param = {
                            oddNum: this.oddNum,
                            auditType: 0,
                            auditState: this.form.auditState,
                            auditOpinion: this.form.auditOpinion,
                        }
                        this.$store.dispatch('AnnualReview/GET_UPDATEAUDIT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getCarAnnualList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }
    
                        }).catch(err => { })
                    }
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                auditState: 1,
                auditOpinion: ''
            }
        },
        closeDia() {
            this.form = {
                auditState: 1,
                auditOpinion: ''
            }
            this.dialogFormVisible = false;
        },

        closeImgDia() {
            this.dialogImgFormVisible = false
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getCarAnnualList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}